import pagination from "../static/pagination";
// import selectedStatus from "../static/selectedStatus";

const mutations = {
    setLoadMore: (state, payload) => {
        state.isLoadMore = payload;
    },
    setFilter: (state, payload) => {
        state.isFilter = payload;
    },
    setResponse: (state, payload) => {
        state.response = payload;
    },

    toggleExport: (state, payload) => {
        state.exportData.exporting = payload;
    },
    setMinimizedExport: (state, payload) => {
        state.exportData.minimized = payload;
    },
    setMultipleExport: (state, payload) => {
        state.exportData.multiple = payload;
    },
    setDataExport: (state, payload) => {
        state.exportData.data = payload;
    },
    setCountDataExport: (state, payload) => {
        state.exportData.dataLength = payload;
    },
    setProgressExport: (state, payload) => {
        state.exportProgress.processed = Number(payload.processed);
        state.exportProgress.total = Number(payload.total);
    },

    resetList: (state, { target }) => {
        state[`${target}List`] = [];
        state[`${target}Total`] = 0;

        if (target === "transaksi") {
            state.selectedTransaksi = [];
        }
    },
    resetPage: (state, { target }) => {
        state[`${target}Page`] = pagination();
    },
    setInvoiceData: (state, payload) => {
        state.invoiceData = payload.data;
    },
    toggleSelectedTransaksi: (state, payload) => {
        let exists = state.selectedTransaksi.find((transaksi) => transaksi === payload);

        let selected = state.transaksiList.find((e) => e.idtransaksi === payload);

        if (exists === undefined) {
            state.selectedTransaksi.push(payload);
            state.grandTotal = parseFloat(state.grandTotal) + selected.grandtotal;
            state.unSelectedTransaksi = state.unSelectedTransaksi.filter((tr) => tr !== payload);
        } else {
            state.selectedTransaksi = state.selectedTransaksi.filter((transaksi) => transaksi !== payload);
            state.unSelectedTransaksi.push(payload);
            state.grandTotal = parseFloat(state.grandTotal) - selected.grandtotal;
        }
    },
    setCheckAll: (state, payload) => {
        state.isCheckAll = payload;
    },
    setSelectedTransaksi: (state, payload) => {
        state.selectedTransaksi = payload;
    },
    setUnselectedTransaksi: (state, payload) => {
        state.unSelectedTransaksi = payload;
    },
    setReminders: (state, payload) => {
        state.reminders = state.reminders.concat(payload);
    },
    removeReminders: (state, payload) => {
        state.reminders = state.reminders.filter((reminder) => reminder !== payload);
    },

    setInvoiceList: (state, payload) => {
        state.invoiceList = state.invoiceList.concat(payload.array);
        state.invoiceTotal = payload.count;
    },
    setInvoiceEnd: (state, payload) => {
        state.invoiceEnd = payload;
    },
    setNextInvoicePage: (state, payload) => {
        state.invoicePage.length += payload.length;
        state.invoicePage.pageNumber++;
        state.invoicePage.offset = state.invoicePage.pageNumber * state.invoicePage.limit;
    },
    setLastInvoiceView: (state, payload) => {
        state.invoiceView = payload;
    },
    toggleInvoiceShow: (state, payload) => {
        let etIdx = state.invoiceShow.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.invoiceShow.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.invoiceShow.splice(etIdx, 1);
        }
    },
    setGrandTotal: (state, payload) => {
        state.grandTotal = payload;
    },

    setTransaksiList: (state, payload) => {
        state.transaksiList = state.transaksiList.concat(payload.array);
        state.transaksiTotal = payload.count;
        state.grandTotalCheck = parseInt(payload.grandtotal);
        if (state.isCheckAll === false) {
            state.grandtotal = 0;
            return;
        } else {

            let transaksi = payload.array !== null ? payload.array : [];
            let SelectedTransaksi = [];

            transaksi.forEach((data) => {
                // if (undefined !== selectedStatus.find((stat) => stat === data.status.toLowerCase())) {
                // }
                SelectedTransaksi.push(data.idtransaksi);
            });
            state.grandtotal = parseInt(payload.grandtotal);
            state.selectedTransaksi = state.selectedTransaksi.concat(SelectedTransaksi);
            state.isCheckAll = transaksi.length > 0 ? true : false;
        }
    },
    setTransaksiEnd: (state, payload) => {
        state.transaksiEnd = payload;
    },
    setNextTransaksiPage: (state, payload) => {
        state.transaksiPage.length += payload.length;
        state.transaksiPage.pageNumber++;
        state.transaksiPage.offset = state.transaksiPage.pageNumber * state.transaksiPage.limit;
    },
    setLastTransaksiView: (state, payload) => {
        state.transaksiView = payload;
    },
    toggleTransaksiShow: (state, payload) => {
        let etIdx = state.transaksiShow.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.transaksiShow.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.transaksiShow.splice(etIdx, 1);
        }
    },

    setKonsumenList: (state, payload) => {
        state.konsumenList = state.konsumenList.concat(payload.array);
        state.konsumenTotal = payload.count;
    },
    setKonsumenEnd: (state, payload) => {
        state.konsumenEnd = payload;
    },
    setNextKonsumenPage: (state, payload) => {
        state.konsumenPage.length += payload.length;
        state.konsumenPage.pageNumber++;
        state.konsumenPage.offset = state.konsumenPage.pageNumber * state.konsumenPage.limit;
    },
    setLastKonsumenView: (state, payload) => {
        state.konsumenView = payload;
    },
    toggleKonsumenShow: (state, payload) => {
        let etIdx = state.konsumenShow.findIndex((item) => item.id === payload.data.id);
        if (etIdx === -1 && payload.mode === "add") {
            state.konsumenShow.push(payload.data);
        }

        if (etIdx !== -1 && payload.mode === "remove") {
            state.konsumenShow.splice(etIdx, 1);
        }
    },
    setDataModal: (state, payload) => {
        state.dataModal = payload
    },
    setKonsumenSchedule: (state, payload) => {
        state.listKonsumenSchedule = payload
    },
    setDetailPenjadwalan: (state, payload) => {
        state.penjadwalanDetail = payload
    },
    setPenjadwalanList: (state, payload) => {
        state.penjadwalanList = payload
    },
    addDataPenjadwalanList: (state, payload) => {
        state.penjadwalanList.data = [
            ...state.penjadwalanList.data,
            ...payload
        ]
    },
    resetPenjadwalanList: (state) => {
        state.penjadwalanList = {
            count: 0,
            data: []
        }
    },
    setMcoinEstimation: (state, payload) => {
        state.mcoinEstimation = payload
    }
};

export default mutations;
